export var DirectoryEntityType;
(function (DirectoryEntityType) {
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_UNSPECIFIED"] = "DIRECTORY_ENTITY_TYPE_UNSPECIFIED";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_USER"] = "DIRECTORY_ENTITY_TYPE_USER";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_GROUP"] = "DIRECTORY_ENTITY_TYPE_GROUP";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_ORG_UNIT"] = "DIRECTORY_ENTITY_TYPE_ORG_UNIT";
})(DirectoryEntityType || (DirectoryEntityType = {}));
